import React, { useState, useRef } from 'react'

import {
  Button, Icon, FilterIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

let RemainingFilters

function LazyRemainingFilters() {
  const [isLoaded, setIsLoaded] = useState(false)
  const buttonRef = useRef(null)

  function imporModules() {
    import('./RemainingFilters').then((module) => {
      RemainingFilters = module.default
      setIsLoaded(true)

      // dirty hackery here
      if (buttonRef && buttonRef.current) {
        buttonRef.current.children[0].click()
      }
    })
  }

  function handleFirstClick() {
    imporModules()
  }

  function getTrigger(onClick = null, isActive = false) {
    return (
      <div className="cgt-ml-20 wayfinder__remaining-filters" ref={buttonRef}>
        <Button
          title="Filters"
          icon={<Icon svgComponent={FilterIcon} notSpaced />}
          type="secondary"
          variant="only-icon"
          customClass="remaining-filters__button"
          onClick={onClick}
          isActive={isActive}
        />
      </div>
    )
  }

  if (isLoaded && !!RemainingFilters) {
    return (
      <RemainingFilters getTrigger={getTrigger} />
    )
  }

  return getTrigger(handleFirstClick)
}

export default LazyRemainingFilters
